//#region src/types/index.ts
let BlockTypes = /* @__PURE__ */function (BlockTypes$1) {
  BlockTypes$1["DOCUMENT"] = "doc";
  BlockTypes$1["HEADING"] = "heading";
  BlockTypes$1["PARAGRAPH"] = "paragraph";
  BlockTypes$1["QUOTE"] = "blockquote";
  BlockTypes$1["OL_LIST"] = "ordered_list";
  BlockTypes$1["UL_LIST"] = "bullet_list";
  BlockTypes$1["LIST_ITEM"] = "list_item";
  BlockTypes$1["CODE_BLOCK"] = "code_block";
  BlockTypes$1["HR"] = "horizontal_rule";
  BlockTypes$1["BR"] = "hard_break";
  BlockTypes$1["IMAGE"] = "image";
  BlockTypes$1["EMOJI"] = "emoji";
  BlockTypes$1["COMPONENT"] = "blok";
  BlockTypes$1["TABLE"] = "table";
  BlockTypes$1["TABLE_ROW"] = "tableRow";
  BlockTypes$1["TABLE_CELL"] = "tableCell";
  BlockTypes$1["TABLE_HEADER"] = "tableHeader";
  return BlockTypes$1;
}({});
let MarkTypes = /* @__PURE__ */function (MarkTypes$1) {
  MarkTypes$1["BOLD"] = "bold";
  MarkTypes$1["STRONG"] = "strong";
  MarkTypes$1["STRIKE"] = "strike";
  MarkTypes$1["UNDERLINE"] = "underline";
  MarkTypes$1["ITALIC"] = "italic";
  MarkTypes$1["CODE"] = "code";
  MarkTypes$1["LINK"] = "link";
  MarkTypes$1["ANCHOR"] = "anchor";
  MarkTypes$1["STYLED"] = "styled";
  MarkTypes$1["SUPERSCRIPT"] = "superscript";
  MarkTypes$1["SUBSCRIPT"] = "subscript";
  MarkTypes$1["TEXT_STYLE"] = "textStyle";
  MarkTypes$1["HIGHLIGHT"] = "highlight";
  return MarkTypes$1;
}({});
let TextTypes = /* @__PURE__ */function (TextTypes$1) {
  TextTypes$1["TEXT"] = "text";
  return TextTypes$1;
}({});
let LinkTargets = /* @__PURE__ */function (LinkTargets$1) {
  LinkTargets$1["SELF"] = "_self";
  LinkTargets$1["BLANK"] = "_blank";
  return LinkTargets$1;
}({});
let LinkTypes = /* @__PURE__ */function (LinkTypes$1) {
  LinkTypes$1["URL"] = "url";
  LinkTypes$1["STORY"] = "story";
  LinkTypes$1["ASSET"] = "asset";
  LinkTypes$1["EMAIL"] = "email";
  return LinkTypes$1;
}({});

//#endregion
export { BlockTypes, LinkTargets, LinkTypes, MarkTypes, TextTypes };
